import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import Spinner from "../../../components/ui/spinner";
import { getUsersRange } from "../../../services/apiservices/support";
import { getStripeConfigs } from "../../../services/apiservices/users";
import { Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

const AccountTypesCard = ({ timeRange }) => {
  const [accountTypes, setAccountTypes] = useState();
  const [loading, setLoading] = useState(true);

  const planColors = {
    Free: "#8dd1e1",
    Standard: "#8884d8",
    Plus: "#82ca9d",
    Professional: "#ffc658",
  };

  useEffect(() => {
    const fetchData = async () => {
      setAccountTypes();
      setLoading(true);
      try {
        const [usersData, stripeConfig] = await Promise.all([
          getUsersRange(timeRange, "all", false, true),
          getStripeConfigs(),
        ]);

        const prices = stripeConfig?.data?.prices || [];
        const priceMap = {};
        prices.forEach((p) => {
          if (p.product?.name) {
            priceMap[p.id] = p.product.name;
          }
        });

        const counts = {
          Free: 0,
          Standard: 0,
          Plus: 0,
          Professional: 0,
        };

        for (const user of usersData || []) {
          if (user?.role === "companyUser") {
            const subscriptions = user.subscriptions?.data || [];

            for (const sub of subscriptions) {
              if (sub.status === "trialing" || sub.status === "active") {
                const priceId = sub?.items?.data?.[0]?.price?.id;
                let planName = priceMap[priceId] || "Standard";

                if (planName === "Users Plan") continue;

                counts[planName] = (counts[planName] || 0) + 1;
                break; 
              }
            }
          }
        }

        const accountTypeData = Object.entries(counts)?.map(
        ([name, value]) => ({
          name,
          value,
          color: planColors[name] || "#ccc",
        })
      );
      setAccountTypes(accountTypeData);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [timeRange]);

  return (
    <Card className="bg-white dark:bg-[#2c3440] p-24">
      <CardHeader className="p-24">
        <CardTitle>Account Types Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Spinner size="lg" />
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={accountTypes}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {accountTypes?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry?.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default AccountTypesCard;
